import "./App.scss";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  
} from "react-router-dom";
import Order from "./main-page/order/Order";
import Users from "./main-page/users/Users";
import UserDetailsPage from "./main-page/users/UserDetailsPage";
import Transaction from "./main-page/transaction/Transaction";
import Agent from "./main-page/agent/Agent";
import Product from "./main-page/product/Product";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Categories from "./main-page/categories/Categories";
import UserLevels from "./main-page/user-levels/UserLevels";
import Layout from "./main-page/drower/Drower";
import Dashboard from "./main-page/over-view/Dashboard";
import ProfitMargin from "./main-page/ProfitMargin/ProfitMargin";
import PaymentMMethods from "./main-page/Payment-methods/PaymentMMethods";
import ExpensesSummary from "./main-page/ExpensesSummary/ExpensesSummary";
import LoginForm from "./main-page/login/LoginPage";
import SettingsPage from "./main-page/settings/SettingsPage";
import { ErrorProvider, useError } from "./contexts/ErrorContext";
import { PermissionsProvider } from "./contexts/PermissionsContext";
import ForbiddenModal from "./components/ErrorModal/ForbiddenModal";
import { setForbiddenErrorCallback } from "./utils/axiosConfig";
import { useEffect } from "react";
import Employees from "./main-page/employees/Employees";
import EmployeeDetails from "./main-page/employees/EmployeeDetails";
import EmployeePermissions from "./main-page/employees/EmployeePermissions";
import ActivityLogs from "./main-page/activity-logs/ActivityLogs";
import DayDetails from "./main-page/ProfitMargin/DayDetails";
import AgentDetails from "./main-page/ProfitMargin/AgentDetails";
import ProductDetails from "./main-page/product/product-details/ProductDetails";
import ProductAgents from "./main-page/product/product-agents/ProductAgents";
import ProductAnalytics from "./main-page/product/product-analytics/ProductAnalytics";
import TransactionsReport from "./main-page/transaction/TransactionsReport";
import DayDetailsPage from "./main-page/transaction/DayDetailsPage";
import AgentProducts from "./main-page/agent/AgentProducts";
import { NotificationProvider } from "./contexts/NotificationContext";
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import { usePermissionsSync } from "./hooks/usePermissionsSync ";
import UserCustomPricing from "./main-page/users/UserCustomPricing";

// Component to setup error callback
const ErrorSetup = () => {
  const { showForbiddenError } = useError();

  useEffect(() => {
    setForbiddenErrorCallback(showForbiddenError);
  }, [showForbiddenError]);

  return null;
};

// ✨ Component لتفعيل Permissions Sync
const PermissionsSync = () => {
  usePermissionsSync(30000); // كل 30 ثانية
  return null;
};

// Global Error Modal Component
const GlobalErrorModal = () => {
  const { forbiddenError, hideForbiddenError } = useError();

  return (
    <ForbiddenModal
      isOpen={forbiddenError.isOpen}
      onClose={hideForbiddenError}
      message={forbiddenError.message}
    />
  );
};

// ✨ Simple Auth Check Component
const AuthCheck = ({ children }) => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Protected Layout Component
const ProtectedLayout = () => {
  return (
    <AuthCheck>
      <PermissionsSync />
      <NotificationProvider>
        <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              className="z-[99999999999]"
            />
      <Layout />
      </NotificationProvider>
    </AuthCheck>
  );
};

function App() {
  const accessToken = localStorage.getItem("accessToken");

  return (
    <ErrorProvider>
      <PermissionsProvider>
          <Router>
            <ErrorSetup />
            <GlobalErrorModal />
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              className="z-[99999999999]"
            />
            <Routes>
              {/* Public Route */}
              <Route
                path="/login"
                element={
                  accessToken ? <Navigate to="/" replace /> : <LoginForm />
                }
              />
              {/* ✨ Protected Routes with Permissions */}

              {/* Protected Routes */}
              <Route element={<ProtectedLayout />}>
                <Route
                  index
                  element={
                    <ProtectedRoute permission="view_dashboard_stats">
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="order"
                  element={
                    <ProtectedRoute permission="view_all_orders">
                      <Order />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="user"
                  element={
                    <ProtectedRoute permission="view_all_users">
                      <Users />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="user/:id"
                  element={
                    <ProtectedRoute permission="view_user_details">
                      <UserDetailsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="user/:profile_id/custom-pricing"
                  element={
                    <ProtectedRoute permission="">
                      <UserCustomPricing />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="user-levels"
                  element={
                    <ProtectedRoute permission="view_all_users">
                      <UserLevels />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="transaction"
                  element={
                    <ProtectedRoute permission="view_all_transactions">
                      <Transaction />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="transaction/report"
                  element={
                    <ProtectedRoute permission="view_daily_transactions_summary">
                      <TransactionsReport />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="transaction/day/:date"
                  element={
                    <ProtectedRoute permission="view_all_transactions">
                      <DayDetailsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="profit-margin"
                  element={
                    <ProtectedRoute permission="view_profit_reports">
                      <ProfitMargin />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="profit-margin/day/:date"
                  element={
                    <ProtectedRoute permission="view_profit_reports">
                      <DayDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="profit-margin/agent/:agentName/:date"
                  element={
                    <ProtectedRoute permission="view_profit_reports">
                      <AgentDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="Payment-methods"
                  element={
                    <ProtectedRoute permission="view_payment_methods">
                      <PaymentMMethods />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="expenses-summary"
                  element={
                    <ProtectedRoute permission="view_expenses">
                      <ExpensesSummary />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="agent"
                  element={
                    <ProtectedRoute permission="view_agents">
                      <Agent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="agent/:agentId/products"
                  element={
                    <ProtectedRoute permission="view_agents">
                      <AgentProducts />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="categories"
                  element={
                    <ProtectedRoute permission="view_banners">
                      <Categories />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="product"
                  element={
                    <ProtectedRoute permission="view_products">
                      <Product />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="product/:id"
                  element={
                    <ProtectedRoute permission="view_products">
                      <ProductDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="product/:id/agents"
                  element={
                    <ProtectedRoute permission="view_products">
                      <ProductAgents />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="product/:id/analytics"
                  element={
                    <ProtectedRoute permission="view_products">
                      <ProductAnalytics />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="settings"
                  element={
                    <ProtectedRoute permission="view_website_settings">
                      <SettingsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="employees"
                  element={
                    <ProtectedRoute permission="">
                      <Employees />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="employees/:id"
                  element={
                    <ProtectedRoute permission="">
                      <EmployeeDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="employees/:id/permissions"
                  element={
                    <ProtectedRoute permission="">
                      <EmployeePermissions />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="activity-logs"
                  element={
                    <ProtectedRoute permission="view_dashboard_stats">
                      <ActivityLogs />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Catch all other routes */}
              <Route
                path="*"
                element={
                  accessToken ? (
                    <Navigate to="/" replace />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
            </Routes>
          </Router>
      </PermissionsProvider>
    </ErrorProvider>
  );
}

export default App;
